export default __webpack_public_path__ + "static/media/barker.2fbcf9f0.png";